let personalData = {
    title: "个人资料",
    info: "基本信息",
    head: "头像",
    footerTitle: "第三方认证源",
    unbind: "解绑",
    unbindSub: "确定要解绑",
    source: "认证源？",
    import: "请输入",
    select: "请选择",
    rulesFun: "请输入1-32位字符，支持数字、中文、大小写字母，以及特殊字符!@#$%^&*()_.",
    onlyNum: "只能输入数字！",
    maxNum: "最大可输入9007199254740991！",
    addSuc:"添加成功！",
    editSuc:"修改成功！",
    maxLength:"最多只可添加5个属性值！",
    requireTrue:"是必填项，不能为空！",
    multivalue:"支持输入多个属性值",
}

export default personalData